import PropTypes from "prop-types";
import React from "react";

import styled from "styled-components/macro";

import { motion } from "framer-motion";

import { getGradient } from "./gradients";

Report.propTypes = {
  report: PropTypes.object,
  householdID: PropTypes.number,
};

export default function Report({ report, householdID }) {
  const { startDate, endDate } = report;

  //todo how do we get the gradient if report spans multiple years?
  const gradient = getGradient(new Date(startDate).getUTCFullYear());

  if (report.status !== "active") {
    return null;
  }
  return (
    <Wrapper>
      <Link
        href={`/giving/taxSummary?startDate=${startDate}&endDate=${endDate}&householdID=${householdID}`}
        target="_blank"
        rel="noreferrer"
        download={`${report.title} Donor Summary`}
      >
        <ReportDoc
          style={{
            background: `linear-gradient(to bottom right, ${gradient[0]}, ${gradient[1]})`,
          }}
          whileHover={{ scale: 1.1 }}
          whileTap={{
            scale: window.matchMedia("(pointer: fine)").matches ? 1.05 : 0.95,
          }}
        >
          <Stripe1 />
          <Stripe2 />
          <ReportLabel>
            <ReportYear>{report.title}</ReportYear>
            Donor Summary
          </ReportLabel>
        </ReportDoc>
      </Link>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  flex-shrink: 0;
  flex-grow: 0;
`;

const Link = styled.a`
  display: block;
  text-decoration: none !important;
`;

const ReportDoc = styled(motion.div)`
  height: 140px;
  aspect-ratio: 8.5 / 11;
  font-weight: 400;
  padding: 11px;
  border-radius: 5px;
  box-shadow: rgba(0, 0, 0, 0.5) 1px 1px 4px;
  box-sizing: border-box;
  overflow: hidden;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
`;

const Stripe = styled.div`
  position: absolute;
  left: 0;
  width: 100%;
  height: 100%;
  clip-path: polygon(0 0, 100% 28%, 100% 48%, 0 20%);
  background: rgba(255, 255, 255, 0.2);
`;

const Stripe1 = styled(Stripe)`
  top: -7px;
`;

const Stripe2 = styled(Stripe)`
  top: 26px;
`;

const ReportLabel = styled.div`
  font-size: 18px;
  line-height: 20px;
  text-shadow: rgba(0, 0, 0, 0.4) 1px 1px 3px;
`;

const ReportYear = styled.div`
  font-size: 18px;
  line-height: 1em;
  font-weight: 800;
  margin-bottom: 1px;
  font-variant-numeric: tabular-nums;
`;
